import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { isAuthenticated, error, authenticate } from "./contextSlice";
import { useHistory } from "react-router-dom";

import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const Login = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isUserAuthenticated = useSelector(isAuthenticated);
  const loginError = useSelector(error);
  const history = useHistory();

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (loginError) {
      setErrorMessage(loginError);
    }
  });

  const submitLoginForm = () => {
    if (!userName || !password) {
      setErrorMessage("UserName and Password is required");
      return;
    }

    dispatch(authenticate(userName, password));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      submitLoginForm();
    }
  };

  if (isUserAuthenticated) {
    history.push("/home");
    return null;
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={userName}
            error={!!errorMessage}
            helperText={errorMessage ?? ""}
            onChange={(e) => {
              setErrorMessage("");
              setUserName(e.target.value);
            }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            error={!!errorMessage}
            helperText={errorMessage ?? ""}
            value={password}
            onChange={(e) => {
              setErrorMessage("");
              setPassword(e.target.value);
            }}
          />

          <Button
            // type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={submitLoginForm}
            onKeyPress={(e) => handleKeyDown(e)}
          >
            Sign In
          </Button>

          {/* TODO: Create forgotten password and register page */}
          <Grid container>
            <Grid item xs>
              <Link href="#" variant="body2">
                Forgot password have you?
              </Link>
            </Grid>
            <Grid item>
              <Link href="#" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
    </Container>
  );
};

export default Login;
